module.exports = __webpack_public_path__ + "img/orb-3.fbfe540f.svg";